import { render, staticRenderFns } from "./BaseSelectUploadResource.vue?vue&type=template&id=5427fea5&scoped=true&"
import script from "./BaseSelectUploadResource.vue?vue&type=script&lang=js&"
export * from "./BaseSelectUploadResource.vue?vue&type=script&lang=js&"
import style0 from "./BaseSelectUploadResource.vue?vue&type=style&index=0&id=5427fea5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5427fea5",
  null
  
)

export default component.exports